import { useEffect, useState } from "react";

export function useNearViewport(rootMargin = "200px") {
  const [node, setNode] = useState(null);
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    if (!node || isNear) return;
    if (!window.IntersectionObserver) {
      setIsNear(true);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setIsNear(true);
        observer.disconnect();
      }
    }, { rootMargin });
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, isNear, rootMargin]);

  return [setNode, isNear];
}
